import React, { useRef, useContext, useState, useEffect } from "react";
import pencil from "../../assets/pencil.png";
import trash from "../../assets/trash.png";
import printer from "../../assets/Printer.png";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useReactToPrint } from 'react-to-print';
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import { SetEditReturn, GetCarrierBagStoreList, SetCarrierBagStoreList } from "../../store/carrierBagReturn";
import { rewardService } from "../../services/Reward.service";
import LogicContext from "../../Context/LogicContext";
import CarrierScroller from "./CarrierScroller";

const CarrierDetailsPage = () => {
  const [selectedList, setSelectedList] = useState([]);
  const myPromiseModal = createModal(GeneralModal);
  const setEditReturn = SetEditReturn();
  const getReturnList = GetCarrierBagStoreList();
  const setReturnList = SetCarrierBagStoreList();
  const { id } = useParams();
  const navigate = useNavigate();
  const logicContext = useContext(LogicContext);
  const [historyDetails, setHistoryDetails] = useState({});
  const { pathname } = useLocation();
  const printRef = useRef();

  const url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  useEffect(() => {
    document.title = 'Reward history details';
    let isMounted = true;
    rewardService.carrierDetails(id).then((response) => {
      if (isMounted && response.data[0]) {
        setHistoryDetails(response.data[0]);
      }
    });
    return () => {
      isMounted = false;
    };
  }, [id]);

  const getHistoryDetails = async (id) => {
    rewardService.carrierDetails(id).then((response) => {
      if (response.data[0]) {
        setHistoryDetails(response.data[0]);
      }
    });
  };

  const editCurrentData = async () => {
    const response = await myPromiseModal({
      title: "Modify Return",
      body: "Do you want to modify this record?",
      showInput: false,
      placeHolder: ""
    });
    if (response.decision === true) {
      setEditReturn(historyDetails);
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
    }
  };

  const deleteCurrentData = async () => {
    const response = await myPromiseModal({
      title: "Delete Return",
      body: "Do you want to delete this record?",
      showInput: false,
      placeHolder: ""
    });
    if (response.decision === true) {
      rewardService.deleteReturn(id).then((res) => {
        const data = logicContext.httpResponseManager(res.data[0]);
        if (data?.message_id === 1) {
          const newList = getReturnList.filter((item) => item?.Ref_No !== id);
          setReturnList(newList);
          logicContext.showToast(data?.message_text, 'success');
          navigate(-1);
        }
      });
    }
  };

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: `Carrier_Details_${historyDetails?.Ref_No}`,
    onAfterPrint: () => console.log('Printed successfully'),
  });

  const onSelection = (list) => {
    let tempList = list?.filter((item) => item.checked === true);
    setSelectedList(tempList);
  };

  const manageStatus = (statusCode, statusName) => {
    let defaultClass = 'bg-blue-600 text-white';
    switch (statusCode) {
      case 1: defaultClass = 'bg-green-600 text-white'; break;
      case 2: defaultClass = 'bg-yellow-600 text-white'; break;
      case 3: defaultClass = 'bg-red-600 text-white'; break;
      case 4: defaultClass = 'bg-purple-600 text-white'; break;
      case 5: defaultClass = 'bg-orange-600 text-white'; break;
      case 6: defaultClass = 'bg-gray-600 text-white'; break;
      default: break;
    }
    return (
      <span className={`py-1 px-3 text-sm font-semibold rounded-full ${defaultClass}`}>
        {statusName}
      </span>
    );
  };

  return (
    <section className="mt-4 max-w-6xl mx-auto px-4">
      {/* Action Buttons */}
      <div className="flex justify-end space-x-3 mb-6">
      <button
       onClick={handlePrint}
                      style={{ borderRadius: "5px" }}
                      className=" px-3  h-[6vh] text-filterTextColor bg-filterColor lg:pt-1 mr-3"
                    >
                      <img src={printer} alt="" className="" />
                    </button>

                    <button
                      style={{ borderRadius: "5px" }}
                      onClick={editCurrentData}
                      className="px-3 mr-2 h-[6vh] text-filterTextColor bg-filterColor lg:pt-1 "
                    >
                      <img src={pencil} alt="" />
                    </button>
                    <button
                      onClick={deleteCurrentData}
                      style={{ borderRadius: "5px" }}
                      className="  px-3 h-[6vh] text-filterTextColor bg-filterColor lg:pt-1 ml-2"
                    >
                      <img src={trash} alt="" />
                    </button>
      </div>

      {/* Main Content */}
      <div className="flex flex-col md:flex-row gap-6">
        {/* Carrier Scroller */}
        <div className="w-full md:w-1/3">
          <CarrierScroller onSelection={onSelection} viewItemDetails={getHistoryDetails} />
        </div>

        {/* Package Details */}
        <div className="w-full md:w-2/3" ref={printRef}>
          <div className="border-2 border-gray-200 rounded-lg p-6 bg-white shadow-sm">
            <div className="flex flex-col md:flex-row justify-between gap-6">
              {/* Customer Info */}
              <div className="flex-1">
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-center">
                    <span className="w-24 font-medium">Ref. No</span>
                    <span className="font-bold">{historyDetails?.Ref_No}</span>
                  </li>
                  <li className="flex items-center">
                    <span className="w-24 font-medium">Date</span>
                    <span className="font-bold">{historyDetails?.Return_Date_String}</span>
                  </li>
                  <li className="flex items-center">
                    <span className="w-24 font-medium">Name</span>
                    <span className="font-bold">{historyDetails?.Customer_Full_Name}</span>
                  </li>
                  <li className="flex items-center">
                    <span className="w-24 font-medium">Email</span>
                    <span className="font-bold">{historyDetails?.Customer_Email_Address}</span>
                  </li>
                  <li className="flex items-center">
                    <span className="w-24 font-medium">Mobile</span>
                    <span className="font-bold">{historyDetails?.Customer_Mobile_No}</span>
                  </li>
                </ul>
              </div>

              {/* Quantity */}
              <div className="flex-1 text-center">
                <h2 className="text-xl font-bold text-gray-800 mb-2">Quantity</h2>
                <p className="text-3xl font-bold text-gray-900">{historyDetails?.Bag_Quantity}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CarrierDetailsPage;